import { LoadingButton } from '@mui/lab';
import {
  Button,
  CircularProgress,
  DialogTitle,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useDeleteSectionNode from 'api/locationsCategories/useDeleteNode';

const DeleteSectionNodeDialog = props => {
  const { nodeType, nodeName, guid, refreshData } = props;

  const [loading, deleteNode] = useDeleteSectionNode();

  const handleClick = () => {
    deleteNode(nodeType, guid, refreshData);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Dialog
      open={props.show}
      onClose={props.closeHandler}
      sx={{ direction: 'rtl' }}
      onKeyDown={handleKeyDown}
    >
      <DialogTitle>حذف {nodeName}</DialogTitle>

      <DialogContent>از حذف اطمینان دارید؟</DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={handleClick}
        >
          حذف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          loading={loading}
          onClick={props.closeHandler}
        >
          انصراف
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSectionNodeDialog;
